import React, { Component, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import {
  Avatar,
  Grid,
  Chip,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  CardHeader,
  Divider,
  Typography,
  Icon,
  IconButton,
  Slider,
  Tooltip,
  withStyles
} from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup'
import Skeleton from '@material-ui/lab/Skeleton'
import { startCase, kebabCase } from 'lodash'
import { stringToColor } from '../../utils/helpers'
import Cookies from 'universal-cookie'
import { config } from '../../config.js'
import { OCCASIONS } from '../../utils/lists';

const API = config.api.TRAVEL_URL
const cookies = new Cookies();

class TravelPlanCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.saves) !== JSON.stringify(this.props.saves)) {
      this.setState({saves: this.props.saves})
    }
  }

  openTravelPlan = () => {
    this.props.history.push({
      pathname: `/plan/${this.props.id}`,
      state: {
        occasion: this.props.occasion,
        status: this.props.status
      }
    })
  }

  occasionItem = (name) => {
    return OCCASIONS.filter((o) => o.value === name)[0]
  }

  render() {
    const {
      human_title,
      human_dates,
      occasion,
      assistance,
      status,
      step,
      id,
      images,
      loading,
      members,
      classes,
    } = this.props

    return (
      <Card className={classes.card} elevation={0} variant="outlined">
        {!loading && <CardHeader
          classes={{root: classes.header, action: classes.headerAction}}
          avatar={''}
          // action={
          //   <Fragment>
          //     <Chip variant="outlined" size="small" className={classes.status} label={status} />
          //   </Fragment>
          // }
        />}
        <CardActionArea
        component='span'
        onClick={this.openTravelPlan}
        disableRipple>
          {loading ? (
            <Skeleton variant="rect" height={464} className={classes.media} style={{maxHeight: 464}} />
          ) : (
            <CardMedia
              component="img"
              alt={name}
              className={classes.media}
              height="450"
              image={images && images.length > 0 ? images[0].sizes.medium.url.replace('http://', '//') : '/trip.svg'}
              title={name}
            />
          )}
          <CardContent className={loading ? classes.contentLoading : classes.content}>
            <Typography gutterBottom variant="h3" className={classes.name}>
              {members && members.length > 1 ?
                <AvatarGroup classes={{avatar: classes.avatarSmall, root: classes.avatarGroup}} max={2}>
                  {members.map((member, i) => {
                    return <Avatar key={i} alt={member.first_name} className={classes.avatarSmall} src={member.image} style={{color: stringToColor(member.first_name)}} />
                  })}
                </AvatarGroup>
              :
                <Icon className={`notranslate ${classes.occasionIcon}`}>{occasion ? this.occasionItem(occasion).icon : this.occasionItem("other").icon}</Icon>
              }
              {human_title ?
                human_title
              :
                (occasion ? `${occasion === 'other' ? 'Planning a trip' : this.occasionItem(occasion).title}` : `Plan a trip`)
              }
              {human_dates ?
                <small className={classes.smallCountry}>
                  {human_dates}
                </small>
              :
                <small className={classes.smallCountry}>
                  with {members.map((m) => m.first_name ).join(', ')}
                </small>
              }
            </Typography>
            {/* <Divider className={classes.divider}/>
            <Typography gutterBottom variant="h3" className={classes.dates}>
                <Fragment>
                  <AvatarGroup classes={{avatar: classes.avatarSmall, root: classes.avatarGroup}} max={5}>
                    {members.map((member, i) => {
                      return <Avatar key={i} alt={member.first_name} className={classes.avatarSmall} src={member.image} style={{color: stringToColor(member.first_name)}} />
                    })}
                  </AvatarGroup>
                </Fragment>
                {false && travel && travel.header &&
                    <div className={classes.flight}>
                      <div className={`notranslate ${classes.price}`}>
                        {travel.price ? new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currency: travel.currency || 'USD'}).format(travel.price) : ''}
                      </div>
                    </div>
                }
            </Typography> */}
          </CardContent>
        </CardActionArea>
        {/* <CardActions className={classes.actions}>
          {loading ? (
            <Fragment>
              <Skeleton height={9} />
              <Skeleton height={9}  style={{marginLeft: 0}}/>
            </Fragment>
          ) : (
            <Typography component="p" className={classes.intro}>
              {intro}
            </Typography>
          )}
        </CardActions> */}
      </Card>
    )
  }
}

const styles = theme => ({
  card: {
    textAlign: 'left',
    border: '1px solid #f2f2f2',

    '&:hover': {
      boxShadow: '0px 3px 3px -2px rgb(0 0 0 / 5%), 0px 3px 4px 0px rgb(0 0 0 / 5%), 0px 1px 8px 0px rgb(0 0 0 / 5%)',
      border: '1px solid #f2f2f2',
    },
  },
  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover',
    maxHeight: 200,
  },
  intro: {
    overflow: 'hidden',
    height: 34,
    fontSize: '13px',
    padding: 5,
    // marginBottom: 10,
    color: '#555',
  },
  actions: {
    display: 'none',
    padding: '10px 11px',
  },
  smallCountry: {
    display: 'block',
    fontSize: '13px',
    color: '#828282',
    fontWeight: 600,
    marginTop: 8,
    width: 'calc(100% - 90px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'absolute',
  },

  name: {
    overflow: 'hidden',
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    padding: '0px 10px',
    color: '#000',
    fontWeight: 800,
    fontSize: '1.15rem',
    minHeight: 45,

    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
      fontWeight: 800,
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '0.98rem',
      fontWeight: 800,
    },
  },
  dates: {
    overflow: 'hidden',
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#828282',
    textAlign: 'left',
    // borderTop: '1px solid #f2f2f2',
    margin: '5px 10px -5px 10px',
    padding: '5px 0px 5px 0px',
    minHeight: 30,
  },
  flight: {
    float: 'right',
    textAlign: 'right',
  },
  content: {
    padding: '12px',
  },
  header: {
    marginBottom: '-85px',
    zIndex: 98,
    backgroundColor: 'transparent',
    width: 'calc(100% - 32px)',
    position: 'relative',
    padding: '14px 16px',
  },
  headerAction: {
    margin: '0px -3px 0px 0px',
  },
  divider: {
    backgroundColor: '#f2f2f2',
    width: '40%',
    marginTop: 12,
  },
  tooltipRoot: {
    fontSize: 11,
  },
  avatarSmall: {
    width: 36,
    height: 36,
    fontSize: '13px',
    fontWeight: 600,
    backgroundColor: '#fff',
    color: '#25082f',
    border: '1px solid #fff',
  },
  avatarGroup: {
    float: 'right',
  },
  occasionIcon: {
    color: '#02c39a',
    float: 'right',
    fontSize: 27,
  },
  status: {
    borderColor: 'transparent',
    backgroundColor: '#fff',
    color: '#828282',
    fontWeight: 600,
  }
});

export default withStyles(styles)(withRouter(TravelPlanCard));